// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var NewNetTraderMode;
(function (NewNetTraderMode) {
    NewNetTraderMode["LoginMode"] = "LM";
    NewNetTraderMode["WorkMode"] = "WM";
    NewNetTraderMode["ReloginMode"] = "RM";
})(NewNetTraderMode || (NewNetTraderMode = {}));
